export default __webpack_public_path__ + "static/latitiude-scam-alert-8-a01ba0140442fdcc3f54857f2bda5f02.webp";